<template>
	<div ref="handlework" class="handlework" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<el-divider content-position="left">基本信息</el-divider>
		<div class="mainwork">
			<el-row class="row1">
				<el-col :span="6">
					<span>服务单号</span>
					：
					<label>{{ form.q_id }}</label>
				</el-col>
				<el-col :span="5">
					<span>问题类型</span>
					：
					<label>{{ form.q_type }}</label>
				</el-col>
				<el-col :span="5">
					<span>关联单号</span>
					：
					<label>{{ form.p_pkval }}</label>
				</el-col>
				<el-col :span="8">
					<span>提交时间</span>
					：
					<label>{{ form.createtime }}</label>
				</el-col>
			</el-row>
			<el-row class="row2">
				<el-col :span="24">
					<span>标 题</span>
					：
					<label>{{ form.q_title }}</label>
				</el-col>
			</el-row>
		</div>
		<el-divider content-position="left">处理详情</el-divider>
		<div class="workcontext" ref="workcontext" :style="{ height: `${contextHeight}px`, 'overflow-y': 'auto' }">
			<table>
				<tr v-for="item in contextlist">
					<td style="width:50px;">
						<el-avatar v-if="item.u_userid == userid" shape="square" :src="service"></el-avatar>
					</td>
					<td class="tdleft">
						<div v-if="item.u_userid == userid">
							<span>{{ item.u_account }}</span>
							<div class="dialogue">
								<div>{{ item.q_context }}</div>
								<a  v-if="item.isfile == 1" @click="Downfile(item.id)">
									<i class="el-icon-link"></i>
									下载文件
								</a>
							</div>
						</div>
						
					</td>
					<td class="tdcenter">
						<div class="time">{{ item.createtime }}</div></td>
					<td class="tdright">
						<div v-if="item.u_userid != userid">
							<span>{{ item.u_account }}</span>
							<div class="dialogue">
								<div>{{ item.q_context }}</div>
								<a href="#" v-if="item.isfile == 1" @click="Downfile(item.id)">
									<i class="el-icon-link"></i>
									下载文件
								</a>
							</div>
						</div>
					</td>
					<td style="width:50px">
						<el-avatar v-if="item.u_userid != userid" shape="square" :src="client"></el-avatar>
					</td>
				</tr>
			</table>
		</div>
		<el-divider content-position="left" v-if="!showdetail">回复</el-divider>
		<el-row class="handlecontext" v-if="!showdetail">
			<el-col :span="24">
				<el-form ref="form" :model="form" size="small">
					<el-form-item label=""><el-input type="textarea" placeholder="请输入回复内容" rows="3" v-model="context"></el-input></el-form-item>
					<el-form-item label="">
						<el-upload
							name="fileupload"
							class="upload-demo"
							:auto-upload="false"
							:action="uploadurl"
							:file-list="fileList"
							:on-change="UploadChange"
							:on-error="UploadError"
							:on-success="UploadSuccess"
							:show-file-list="false"
							ref="upload"
						>
							<el-button size="mini" type="primary">添加附件</el-button>
							<span style="font-size:9pt;padding-left:5px">每个文件不超过20M</span>
						</el-upload>
						<el-tag
							:style="index == 0 ? '' : 'margin-left:10px'"
							v-for="(file, index) in fileList"
							:key="index"
							closable
							size="mini"
							effect="plain"
							@close="delfile(index)"
						>
							{{ file.name }}
						</el-tag>
					</el-form-item>					
				</el-form>
			</el-col>
		</el-row>
		<el-row v-if="form.u_userid != userid&&!showdetail">
			<el-col :span="24">
				<table>
					<tr style="height:40px;">
						<td style="width:70px;text-align:center;">
							<span>优先级</span>
						</td>
						<td>
							<el-select size="mini" ref="level" v-model="form.q_level" placeholder="请选择优先级" @keyup.native="val => enterinput(val,'','level')">
								<el-option v-for="item in levellist" :key="item.d_name" :label="item.d_name" :value="item.d_name"></el-option>
							</el-select>
						</td>
						<td style="width:120px;text-align:center;">
							<span>下次处理时间</span>
						</td>
						<td>
							<el-date-picker size="mini"
							      v-model="form.nexttime"
							      type="datetime"
							      placeholder="选择时间">
							    </el-date-picker>
						</td>
					</tr>
					<tr>
						<td style="width:70px;text-align:center;">
							<span>备  注</span>
						</td>
						<td colspan="3">
								<el-input size="mini" type="textarea" rows="3" v-model="form.remark"></el-input>
						</td>
					</tr>
				</table>
			</el-col>
		</el-row>
		<el-row class="footerhandler" v-if="!showdetail">
			<el-col :span="5" style="color:transparent">1</el-col>
			<el-col :span="3" class="submitBtn">
				<div @click="submitwork" v-if="form.u_userid == userid">提交</div>
				<div @click="submitwork" v-if="form.u_userid != userid">回复</div>
			</el-col>
			<el-col :span="3" class="submitBtn_cancel"><div @click="goback">取消</div></el-col>
			<el-col :span="3" class="submitBtn_finished" ><div @click="savework(1)">结束服务</div></el-col>
		</el-row>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			windowHeight: window.innerHeight - 145,
			contextHeight: (window.innerHeight * 35) / 100,
			userid:localStorage.getItem('userid'),
			fileList: [],
			filenamelist: [],
			form: {},
			contextlist: [],
			uploadbatch: '',
			q_id: '',
			context: '',
			uploadurl: '',
			service:'',
			client:'',
			successcount:0,
			levellist:[],
			showdetail:false,
			divclass:'handlework'
		};
	},
	mounted() {
		var that=this;
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/workorders/handlework.scss');
			that.service='../../static/'+res+'/image/service.png';
			that.client='../../static/'+res+'/image/client.png';
		});
		if (this.urlparam != undefined) {
			if (this.urlparam.q_id != undefined) {
				this.q_id = this.urlparam.q_id;
			}
			if(this.urlparam.showdetail){
				this.showdetail = this.urlparam.showdetail;
				if(this.showdetail){
					this.contextHeight=(window.innerHeight * 60) / 100;
				}
			}
		}
		this.init();
	},
	methods: {
		init() {
			this.uploadbatch = this.$tool.getGuid();
			this.uploadurl = this.$apiprototype.ApiServer + '/Works/UploadWorkFile?domain=' + this.$apiprototype.WebServer + '&uploadbatch=' + this.uploadbatch;
			//获取服务单详情
			var that = this;
			//滚动到底部
			this.$refs.handlework.scrollTop=this.$refs.handlework.clientHeight;
			if (this.q_id != '') {
				this.$tool.loading('正在加载',this.divclass);
				this.$apipost.get.GetWorkContext({ q_id: this.q_id }).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
						if (res.maincontext != '') {
							that.form = res.maincontext;
							if(that.form.nexttime==undefined||that.form.nexttime==''){
								that.form.nexttime=this.$tool.getdate('HH',5);
							}
							if(that.form.u_userid!=that.userid){
								that.GetLevel(that.form.q_level);
							}
						}
						if (res.list != '') {
							that.contextlist = res.list;
							setTimeout(function(){
								that.$refs.workcontext.scrollTop=that.$refs.workcontext.clientHeight;
							},100);
						}
					}
				});
			}
		},
		//获取优先级
		async GetLevel(level) {
			var that = this;
			this.$apipost.get.dic({ type: '问题优先级' }).then(res => {
				if (res != '') {
					that.levellist = res.data.list;
					if(level!=''){
						var filterlevel=that.levellist.filter(function(e) {return e.d_value==level});
						if(filterlevel.length>0){
							that.form.q_level=filterlevel[0].d_name;
						}
						
					}
				}
			});
		},
		//上传附件改变时
		UploadChange(file, fileList) {
			var that = this;
			if (fileList.length > 0) {
				var list = [];
				fileList.forEach(e => {
					const isLt20M = e.size / 1024 / 1024 < 20;
					if (!isLt20M) {
						this.$tool.message(e.name + '已超过20M,不允许上传', 0);
						this.$refs.upload.abort(e);
					} else {
						list = list.concat(e);
					}
				});
				that.fileList = list;
			}
		},
		UploadError(err, file, fileList) {
			console.log('上传错误 error', err);
		},
		//上传成功
		UploadSuccess(res, file, fileList) {
			//console.log('成功', file);
			if (this.filenamelist.length > 0) {
				this.filenamelist = this.filenamelist.concat({ name: res.filename });
			} else {
				this.filenamelist = [{ name: res.filename }];
			}
			this.successcount = parseInt(this.successcount) + 1;
			if (this.successcount == this.fileList.length) {
				//全部上传完成
				this.uploadbatch = res.batch;
				this.savework(0);
			}
		},
		//移除上传的文件
		delfile(index) {
			this.$refs.upload.abort(this.fileList[index]);
			this.fileList.splice(index, 1);
		},
		//提交
		submitwork() {
			if (this.context == '') {
				this.$tool.message('请填写问题描述', 0);
				return false;
			}
			if (this.fileList.length > 0) {
				this.$refs.upload.submit();
			} else {
				this.savework(0);
			}
		},
		//返回
		goback() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		//type=0 回复 1-结束
		savework(type) {
			var that = this;
			var level=this.levellist.filter(function(e) {return e.d_name==that.form.q_level});
			if(level.length>0){
				this.form.q_level=level[0].d_value;
			}
			var paraminfo = {
				form: this.form,
				context:this.context,
				filenamelist: this.filenamelist,
				uploadbatch: this.uploadbatch,
				isend: type,
				u_userid:localStorage.getItem('userid'),
				u_account:localStorage.getItem('u_account')
			};
			this.$tool.loading('正在提交',this.divclass);
			//提交问题
			this.$apipost.post.SaveWorkContext({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					that.successcount = 0;
					if (res.state == '1') {
						this.$tool.message('提交成功', 1);
						setTimeout(function() {
							that.goback();
						}, 2000);
					} else this.$tool.message(res.message, 0);
				}
			});
		},
		//下载附件
		Downfile(contextid){
			var that=this;
			this.$apipost.get.DownWorkFile({q_id:this.q_id,id:contextid}).then(res => {
				if (res != '') {
					if(res.state=='1'){
						this.$tool.downfile(that,res.filename);
					}else this.$tool.message(res.message, 0);
				}
			});
		}
	}
};
</script>
